import {Router} from 'react-router-dom'
import './main.scss'
import {createBrowserHistory} from 'history'
import HttpService from "./app/util/HttpService";
import App from "./App";
import ReactDOM from "react-dom/client";


const history: any = createBrowserHistory({window})
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <Router history={history}>
        <App/>
    </Router>
);
HttpService.configure();